export default __webpack_public_path__ + "static/media/driverTruck.4756bf55.png";